import { render, staticRenderFns } from "./banners.vue?vue&type=template&id=7e24473c&"
import script from "./banners.vue?vue&type=script&lang=ts&"
export * from "./banners.vue?vue&type=script&lang=ts&"
import style0 from "./banners.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports